import { create } from 'zustand'

type TaskNotificationsState = {
  unread_count: number
  setUnreadCount: (count: number) => void
}

export const useTaskNotificationsStore = create<TaskNotificationsState>((set) => ({
  unread_count: 0,
  setUnreadCount: (count) => set({ unread_count: Math.max(0, count) }),
}))
